import { interfaces } from '@daas-consulting/core-cross-interfaces';
import * as models from '@daas-consulting/security/audit/frontend/models';
import { Observable } from 'rxjs';

export interface AuditService {
  search$(
    criteria: interfaces.CriteriaRequest
  ): Observable<interfaces.PagedList<models.AuditModel>>;
  get$(entity: string, entityId: string): Observable<models.AuditModel | null>;
  history$(entity: string, entityId: string): Observable<models.AuditModel[]>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  detail$(
    entity: string,
    entityId: string,
    seq: number
  ): Observable<any | null>;
}

export const SecurityAuditServiceId = 'AuditServiceId';
